export enum ReportStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export enum ReportStatusLabels {
  PENDING = 'Zlecony',
  COMPLETED = 'Wygenerowany',
  FAILED = 'Błąd',
}

export const ReportStatusLabel: Record<ReportStatus, string> = {
  [ReportStatus.PENDING]: 'Zlecony',
  [ReportStatus.COMPLETED]: 'Wygenerowany',
  [ReportStatus.FAILED]: 'Błąd',
};

export type ReportStatusOption = {
  label: string;
  key: ReportStatus;
};
